module.exports = __webpack_public_path__ + "img/blue_098.61bc46a4.png";